import { useEffect, useState } from "react";
import { FaLinkedinIn } from "react-icons/fa";
import { getAllTeamMembers } from "../../Api";

const ManagementTeam = ({ language = "EN" }) => {

  const lang = language === "CN" ? "zh" : "en";

  const [teamMembers, setTeamMembers] = useState([]);

  const text = {
    en: {
      title: "Our Team",
      desc:
        "Our advisors come from diverse backgrounds — but they all share the same drive: to make a meaningful difference in the lives of their clients.",
    },

    zh: {
      title: "我们的团队",
      desc:
        "我们的顾问来自不同背景，但拥有共同目标。",
    },
  };


  // ✅ API LOAD
  useEffect(() => {

    const loadData = async () => {

      try {

        const res = await getAllTeamMembers();

        if (res.data.success) {

          const data = res.data.data;

         const filtered = data.filter((item) => {

  const slug =
    item?.category?.slug?.toLowerCase() || "";

  const name =
    item?.category?.name?.en?.toLowerCase() || "";

  if (
    slug === "founder-sp-gaby" ||
    slug === "founder-sp-jtgroup" ||
    name.includes("founder-sp-gaby") ||
    name.includes("founder-sp-jtgroup")
  ) {
    return false;
  }

  return true;

});

          // map to old design format
          const mapped = filtered.map((m) => ({

            name: m.name?.[lang],
            role: m.position?.[lang],
            group: m.category?.name?.[lang],
            image:
              process.env.REACT_APP_API_URL?.replace("/api", "") +
              "/" +
              m.image,
            linkedin: m.socialLinks?.linkedin || "#",

          }));

          setTeamMembers(mapped);

        }

      } catch (err) {
        console.log(err);
      }

    };

    loadData();

  }, [lang]);


  const [current, setCurrent] = useState(0);
  const [itemsToShow, setItemsToShow] = useState(5);

  const infiniteMembers = [...teamMembers, ...teamMembers];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) setItemsToShow(1);
      else if (window.innerWidth < 1024) setItemsToShow(3);
      else setItemsToShow(5);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {

    const interval = setInterval(() => {

      setCurrent((prev) =>
        prev === teamMembers.length ? 0 : prev + 1
      );

    }, 2500);

    return () => clearInterval(interval);

  }, [teamMembers]);


  const cardWidth = 100 / itemsToShow;

  return (
    <section className="bg-white pt-10 pb-10 overflow-hidden">
      <div className="max-w-[1320px] mx-auto px-4">

        <div className="text-center mb-8">
          <h2 className="text-[28px] md:text-[34px] font-medium text-[#154059]">
            {text[lang].title}
          </h2>

          <p className="text-gray-600 mt-5 leading-relaxed text-[15px] mx-auto">
            {text[lang].desc}
          </p>
        </div>


        <div className="overflow-hidden">
          <div
            className="flex transition-transform duration-700 ease-in-out"
            style={{
              transform: `translateX(-${current * cardWidth}%)`,
            }}
          >

            {infiniteMembers.map((member, index) => (

              <div
                key={index}
                className="flex-shrink-0 px-2"
                style={{ width: `${cardWidth}%` }}
              >

                <div className="relative group overflow-hidden">

                  <div className="w-full h-[340px] md:h-[380px] bg-[#f7f7f7] group-hover:bg-[#C09F7C] transition duration-500 flex items-end justify-center overflow-hidden">

                    <img
                      src={member.image}
                      alt={member.name}
                      className="h-full object-contain md:object-cover grayscale group-hover:grayscale-0 transition duration-500"
                    />

                  </div>

                  <div className="absolute top-3 left-3 bg-white px-3 py-1 text-xs shadow">
                    {member.group}
                  </div>

                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-[#154059] text-white hover:bg-[#C09F7C] transition opacity-0 group-hover:opacity-100"
                  >
                    <FaLinkedinIn size={12} />
                  </a>

                 <div className="absolute bottom-4 left-4 right-4 bg-white p-3 text-center shadow-md flex flex-col justify-center min-h-[70px]">

  <h3 className="text-sm font-semibold text-[#154059] leading-tight">
    {member.name}
  </h3>

  <p className="text-xs text-gray-600 mt-1 leading-tight">
    {member.role}
  </p>

</div>

                </div>

              </div>

            ))}

          </div>
        </div>

      </div>
    </section>
  );
};

export default ManagementTeam;